/* Versión actual del sistema, cambiar cada vez que se haga una actualización en ambientes medios y altos (stage, qa, uat y prod) 
    La versión se guardará en formato: <año>.<mes>.<día>.v<build-del-dia>
    Por ej: 2023.05.04.v1
*/
export const currentVersion = "2023.09.13.v1";
